import L from 'leaflet';
import request from '../request';
import { NOMIN_SEARCH } from './constants';

function* lookup(search, locale = 'nl') {
  const options = {
    ...search,
    format: 'json',
    'accept-language': locale,
    polygon_geojson: 1,
  };
  const url = `${NOMIN_SEARCH}${L.Util.getParamString(options)}`;
  try {
    const result = yield request(url);
    return result;
  } catch (err) {
    console.error(err); // eslint-disable-line no-console
    return null;
  }
}

export default lookup;
